import React, { useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { Button, message } from "antd";
import { FileTextOutlined, DownloadOutlined } from "@ant-design/icons";
import { FormSelect } from "../../../common/formValidations";
import API from "../../../../app/helpers/devApi";
import "./TaxCertificateWidget.css";


export function TaxCertificateWidget() {
  const { auth } = useSelector(
    ({ auth }) => ({ auth: auth.coreModuleInfo }),
    shallowEqual
  );
  const employeeId = auth?.employee_id;

  const [selectedYear, setSelectedYear] = useState();
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    if (!employeeId) {
      message.error("Employee ID not found");
      return;
    }
    if (!selectedYear) {
      message.error("Please select a financial year");
      return;
    }

    try {
      setLoading(true);
      message.loading({ content: "Generating Tax Certificate, please wait...", key: "tax_cert", duration: 0 });

      // Call the API to generate the certificate
      const payload = {
        employee_id: employeeId,
        year: parseInt(selectedYear, 10),
      };

      const blobRes = await API.post(
        `/hrms-payroll-service/hrms_tax_employee_wise/tax-certificate/generate`,
        payload,
        { responseType: "blob" }
      );

      const blob = blobRes?.data instanceof Blob ? blobRes.data : new Blob([blobRes?.data ?? blobRes], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Form16_${selectedYear}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      message.success({ content: "Tax certificate downloaded successfully!", key: "tax_cert", duration: 2 });
    } catch (err) {
      console.error("Tax certificate generation failed:", err);
      message.error({ content: err?.message || "An error occurred while generating the certificate", key: "tax_cert", duration: 3 });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tax-certificate-widget">
      <div className="tax-certificate-widget__header">
        <div className="tax-certificate-widget__icon-wrap">
          <FileTextOutlined />
        </div>
        <h3 className="tax-certificate-widget__title">Tax Certificate</h3>
      </div>

      <div className="tax-certificate-widget__content">
        <FormSelect
          name="year"
          slug="hrms_fy_year"
          value={selectedYear || undefined}
          onChange={(val) => setSelectedYear(val)}
          placeholder="Select Financial Year"
          style={{ width: "100%", marginBottom: "16px" }}
          size="large"
        />


        <Button
          type="primary"
          icon={<DownloadOutlined />}
          className="tax-certificate-widget__download-btn"
          size="large"
          onClick={handleDownload}
          loading={loading}
          disabled={loading}
        >
          Download Certificate
        </Button>
      </div>

      <div className="tax-certificate-widget__info-box">
        Tax certificates are generated after the financial year ends and employer files TDS returns.
      </div>
    </div>
  );
}

export default TaxCertificateWidget;
